<template>
    <v-dialog :value="value"
              @input="toggleModal"
              fullscreen
              scrollable
              hide-overlay
              transition="dialog-bottom-transition">
        <v-card class="grey lighten-3">
            <SendSms v-model="showSendSms" type="guests"></SendSms>
            <v-toolbar class="kbPink" dark text flat>
                <v-btn icon @click="toggleModal(false)">
                    <v-icon>arrow_back</v-icon>
                </v-btn>
                <div class="text-h6">{{ `${$t('general.invited')} ${$t('general.people')}` }}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal(false)">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="fill-height">
                <!--<v-col class="pa-2 text-right" cols="12" >
                    <v-btn outlined class="mr-2" color="kbPink">Reenviar invitaciones</v-btn>
                    <v-btn color="kbPink" dark @click="showSendSms = true">Enviar SMS</v-btn>
                </v-col>-->
                <GuestList @openSendSmsDialog="showSendSms = $event"/>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="kbPink"
                       outlined
                       @click="toggleModal(false)">
                    {{ $t('general.accept') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import GuestList from '@/pages/App/People/dialogs/GuestList.vue'
import SendSms from '@/components/dialogs/SendSms.vue'
export default {
  components: { GuestList, SendSms },
  computed: {
    ...mapState({
      loadingRoles: state => state.roles.loadingRoles,
      roles: state => state.roles.roles,
      selectedApp: state => state.apps.selectedApp
    })
  },
  data () {
    return {
      showSendSms: false
    }
  },
  methods: {
    toggleModal (value) {
      this.$emit('input', value)
    }
  },
  props: ['value'],
  watch: {
    selectedApp (value) {
      this.$store.dispatch('getRoles')
    }
  }
}
</script>
